module.exports = __webpack_public_path__ + "static/media/background2.6396edca.jpg";